import React, { } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import PullToRefresh from 'react-simple-pull-to-refresh';
import { uploadTrack } from "shihuo-lib/dist/shihuo-lib";
import moment from 'moment';
class PipelineCutPriceGoodsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      update_time: '',
      list: [],
      showText: false
    };
  }

  componentDidMount() {
    const arrObj = window.location.href.split("?");
    let params = {}
    if (arrObj.length > 1) {
      const arrPara = arrObj[1].split("&");
      let arr;
      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
        if (arr != null && arr[0]) {
          params[arr[0]] = arr[1]
        }
      }
      this.goods_id = (params && params.goods_id) || '';
      this.style_id = (params && params.style_id) || '';
      this.sku_id = (params && params.sku_id) || '';
    }
    this.getData();
    // 点击埋点
    const options = {
      lego_page_id: utils.getPageId(),
      legoAb: this.props.abValue,
      h5Url: window.location.href
    }
    uploadTrack({
      pti: {
        id: `lego-sales:show:`,
        biz: JSON.stringify(options),
        pageOptions: options
      },
    });
  }

  getData(isRefresh = false) {
    return new Promise(resolve => {
      axios({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/goods_price/list?access_token=znSnA7pxO35wtPBaur',
        method: "get",
        withCredentials: true,
        params: {
          is_all: 1,
          list_type: 2,
          page_id: utils.getPageId()
        },
      }).then((res) => {
        setTimeout(() => {
          resolve()
        }, 1000);
        if (res.data.status === 0) {
          const { update_time = '', goods_list = [] } = res.data.data || {}
          let list = []
          if (isRefresh) {
            list = goods_list
          } else {
            let addIndex = -1;
            goods_list && goods_list.map((item, index) => {
              const { goods_id, style_id, sku_id } = item;
              if (goods_id == this.goods_id && style_id == this.style_id && sku_id == this.sku_id) {
                addIndex = index
                list.push(item)
              }
            })
            if (addIndex == -1) {
              list = list.concat(goods_list)
            } else {
              goods_list && goods_list.map((item, index) => {
                if (addIndex != index) {
                  list.push(item)
                }
              })
            }
          }
          this.setState({
            list: list || [],
            update_time,
            showText: true
          })
        }
      }).catch(res => {
        resolve()
      });
    })
  }
  getDateDifference(endTime) {
    if (!endTime) return ''
    //当前时间
    const nowTime = moment(new Date().getTime()).format('YYYY/MM/DD HH:mm:ss');
    const time = moment(new Date(endTime.replace(/-/g, '/'))).diff(moment(nowTime), 'days');
    const day = Math.abs(parseInt(time)) || 0;
    if (day == 0) {
      return moment(new Date(endTime.replace(/-/g, '/')).getTime()).format('HH:mm')
    } else if (day == 1) {
      return '昨天' + moment(new Date(endTime.replace(/-/g, '/')).getTime()).format('HH:mm')
    } else if (day == 2) {
      return '2天前' + moment(new Date(endTime.replace(/-/g, '/')).getTime()).format('HH:mm')
    }
    return endTime

  }
  render() {
    const { list = [], update_time = '', showText = false } = this.state
    const { baseConfig } = this.props.config;
    const isIphoneX = utils.isIphoneX();
    return (
      <PullToRefresh refreshingContent={
        <div className="pulldown-wrapper" style={{paddingTop: isIphoneX ? '32px' : '18px' }}>
          <img src="https://static.shihuocdn.cn/admin/files/20221010/aa28dc1214348a5b360be2767f2d8f43.gif" />
        </div>
      } onRefresh={async () => { await this.getData(true) }}>
        <div
          className="pipeline-cutPriceGoodsList"
          // id={baseConfig.title}
          {...this.props['customAttributes']}
        >
          <div className="item-list"
          >
            <div>
              <div className="top-view">
                <div className="top-one-view">
                  <img src='https://static.shihuocdn.cn/admin/files/20221019/5cd88a3a3d835a9a2378fae5dce4e93c.png' />
                  {/* <LazyLoadImage
                  width="100%"
                  src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20221010/f301915015c3e12e19cc291cf708945f.jpg', this.props.webpSupport)}
                /> */}
                  <span className="update-time">价格更新于{this.getDateDifference(update_time) || '--'}</span>
                </div>

                <div className="top-two-view">
                  <LazyLoadImage
                    width="100%"
                    src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20221011/35b513c4e89a292c3021a5dfd359224f.png', this.props.webpSupport)}
                  />
                  <div className="content-view">
                    <div className="left-view">
                      <div className="top-title">
                        <img src='https://static.shihuocdn.cn/admin/files/20221018/d0bae45ce978c4aadc43361870ea8bc6.gif' />
                        <div className="title">全商品根据系统监控，实时调价</div>
                      </div>
                      <span className="top-desc">严选正品 · 有错必赔 · 售后无忧</span>
                    </div>
                    <img onClick={() => {
                      const href = 'shihuo://www.shihuo.cn?route=fastWebview&url=https%3A%2F%2Fm.shihuo.cn%2Fapp%2Fassets%2Fh5app%2FwrongCompensation.html&navigationBar=false'
                      const ptiOptions = {
                        ptiId: `lego-sales:compensation:`
                      }
                      utils.jumpToUrl(this.props.routeParams, href, href, {}, -1, this.props, false, ptiOptions);
                    }} className="right-view" src='https://static.shihuocdn.cn/admin/files/20221011/82283b3a9b3008a735ef5e5e409e690a.png' />
                  </div>

                </div>
              </div>
              <div className="list-view">
                {list.map((item, index) => {
                  const { pic = '', title = '', avg_order_price_30 = '', now_price = '', price_off = '', style_id = '', goods_id = '', href = '', sku_id = 0 } = item;
                  return <div key={index} className="img-item" onClick={() => {
                    const options = {
                      sort: index,
                      name: title,
                      goods_id,
                      style_id,
                    };
                    const ptiOptions = {
                      ptiId: `lego-sales:list:${index}`,
                      bizExtra: {
                        goods_id,
                        style_id,
                        tab_name: '',
                        goods_sku_id: sku_id
                      }
                    }
                    utils.jumpToUrl(this.props.routeParams, href, href, options, -1, this.props, false, ptiOptions);
                  }}>
                    <div className="img-container">
                      <img src={pic} className="img" />
                      <div className="img-bg"/>
                    </div>
                    
                    {/* <LazyLoadImage
                    className="img"
                    src={utils.formatImgUrl(pic, this.props.webpSupport)}
                  /> */}
                    <div className="right-view">
                      <div className="title">{title}</div>
                      <div className="desc">
                        {/* <div className="red-bg">直降</div> */}
                        <div className="price-bg">
                        <img className="red-bg" src="https://static.shihuocdn.cn/admin/files/20221019/90d08c38b1d643bf9bd42fd82138b1a5.png"/>
                        <div className="pink-bg">¥{price_off || '--'}</div>
                        </div>
                        
                        <div className="gray-text">近30日成交均价 ¥{avg_order_price_30 || '--'}</div>
                      </div>
                      <div className="right-bottom-bg-view">
                        <div className="right-bottom-view">
                          <div className="bottom-right-view">
                            <span className="right-text">立即抢</span>
                          </div>
                          <div className="bottom-left-view">
                            {/* <div className="tag">有错必赔</div> */}
                            <img className="tag" src="https://static.shihuocdn.cn/admin/files/20221019/15f7336a683ae77a6f36b96f401e0712.png"/>
                            <div className="price-view">
                              <span className="unit">¥</span>
                              <span className="price">{now_price || '--'}</span>
                              <span className="price-desc">双12真低价</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                })}
                {showText ? <div className="bottom-desc">
                  <div className="left-line" />
                  <span className="center-desc">没有更多了</span>
                  <div className="right-line" />
                </div>: null}
              </div>

            </div>

          </div>

        </div>
      </PullToRefresh>
    );
  }
}

PipelineCutPriceGoodsList.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCutPriceGoodsList };
export default PipelineCutPriceGoodsList;



// WEBPACK FOOTER //
// ./components/pipeline-cutPriceGoodsList/index.js